import React from 'react';
import { Link } from 'react-router-dom';
import { useT } from '../../../i18n';
import LanguageSwitch from '../../../components/LanguageSwitch';
import MarketingLogo from './MarketingLogo';

interface MarketingHeaderProps {
  guidesLink?: boolean; // lien « Guides » (masqué pendant l'inscription)
  children?: React.ReactNode; // actions supplémentaires après le sélecteur de langue
}

// En-tête du site vitrine : logo à gauche ; guides, langue (+ actions) à droite.
const MarketingHeader: React.FC<MarketingHeaderProps> = ({ guidesLink = true, children }) => {
  const t = useT();
  return (
    <header className="mk-header mk-container">
      <MarketingLogo />
      <nav className="mk-nav" aria-label={t('Navigation principale')}>
        {guidesLink && (
          <Link to="/guides" className="mk-nav-link">
            {t('Guides')}
          </Link>
        )}
        <LanguageSwitch />
        {children}
      </nav>
    </header>
  );
};

export default MarketingHeader;
